/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestRunProgramMessageSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('AUTO_TEST_RUN_PROGRAM_MESSAGE')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecString)],
]);
export class AutoTestRunProgramMessageSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestRunProgramMessageSettingParser.decode(input).map(res => new AutoTestRunProgramMessageSetting(res));
    }
    static unsafeDecode(input) {
        return AutoTestRunProgramMessageSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestRunProgramMessageSettingParser.encode(data);
    }
    static schema() {
        return AutoTestRunProgramMessageSettingParser.schema();
    }
}
